import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import TSEntry from './ts-entry';
import TSEntryDetail from './ts-entry-detail';
import TSEntryUpdate from './ts-entry-update';
import TSEntryDeleteDialog from './ts-entry-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={TSEntryDeleteDialog} />
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={TSEntryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={TSEntryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={TSEntryDetail} />
      <ErrorBoundaryRoute path={match.url} component={TSEntry} />
    </Switch>
  </>
);

export default Routes;
